module.exports = __webpack_public_path__ + "static/media/KPW.a5bd01f2.png";